module.exports = __webpack_public_path__ + "static/media/rewards.576978a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/rewards.png
// module id = 531
// module chunks = 0